var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"custom-select",attrs:{"name":"combobox"},on:{"change":function($event){return _vm.change($event)}}},_vm._l((_vm.values),function(item){return _c('option',{key:item.id,domProps:{"selected":_vm.value==item.id,"value":item.id}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }